<template>
  <!-- 导航 -->
  <NavBar
    class="nav"
    bgcolor="grba(0,0,0,0)"
  >
    <template v-slot:title>
      <span class="nav-title">专辑详情</span>
    </template>
  </NavBar>

  <header>
    <div class="img-box">
      <img :src="album.cover" alt="" />
      <!-- <div class="btn">正在抢购中...</div> -->
    </div>
  </header>
  <main class="bg-color">
    <div class="radius-bar"></div>
    <div class="detail-box">
      <div class="name">{{ album.name }}</div>
      <!-- <div class="xl-list">
        <span class="item"> 大师之作 </span>
        <span class="item"> 大师之作 </span>
        <span class="item"> 大师之作 </span>
      </div> -->
    </div>
    <div class="introduce">
      <div class="title">
        <img :src="album.organization.logo" alt="" />
        <span>{{ album.organization.name }}</span>
      </div>
      <div class="text">{{ album.introduce }}</div>
    </div>

    <!-- <router-link to="/entity/11">
      <div class="commodity-list">
        <div class="box-top">
          <img src="" alt="" />
        </div>

        <div class="box-bottom">
          <p class="title">新版瑞兽“麒麟”数字徽章</p>
          <p class="time">5月10日20:00-24:00合成 <strong>免费获取</strong></p>
          <p class="fee">¥ 49.90</p>
        </div>
      </div>
    </router-link> -->

    <div class="bar"></div>

    <div class="product">
        <p class="title">本期共{{ album.products.length }}件数字藏品</p>
        <p class="describe">购买商品需先去“我的”进行 【实名认证】</p>
        <div class="product-box">
            <div class="item" v-for="product in album.products" :key="product.id">
                <router-link :to="'/product/' + product.id">
                    <div class="box">
                        <van-image class="img-box" :src="product.cover" fit="cover"></van-image>
                        <section class="bottom-box">
                        <p class="title">{{ product.name }}</p>
                        <p class="creater-box">
                            <img class="img-item" round :src="album.organization.logo" >
                            <section class="issuer">
                                <p class="describe">{{ album.organization.name }}</p>
                            </section>
                        </p>
                        <div class="footBox">
                            <p class="fee">
                                <span class="icon">¥</span>{{ product.price }}
                            </p>
                            <p class="quantity">
                                限量<span class="c-blue"> {{ product.total }} </span>件
                            </p>
                        </div>
                        </section>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
  </main>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>